import React, { useState, useEffect } from "react";

import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

const TextInput = ({ label, value, name, myStyle, onChange }) => {
  return (
    <FormControl style={myStyle}>
      {/* <InputLabel id={name}>{"lkj"+label}</InputLabel> */}
      {/* <label>
        {label} */}
      <TextField
        style={{
          paddingTop: "2pt",
          paddingBottom: "2pt",
          marginTop: "0",
          marginBottom: "0",
          backgroundColor: "blue",
        }}
        id={name}
        // label={name}
        type="text"
        value={value}
        onChange={onChange}
        placeholder="..."
        margin="normal"
        name={name}
      />
      {/* </label> */}
    </FormControl>
  );
};
export default TextInput;
